import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    listWrapper: {
        marginBottom: theme.spacing(5),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    }
}));

export default useStyles;
